import { styled } from '@linaria/react';
import { inkDark, secondaryBase, secondaryDarkest, secondaryLightest, skyLight } from '../../../styles/design-tokens';

/** Monospace pill naming the model a turn ran on. */
const ModelBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 99px;
  border: 1px solid ${skyLight};
  background: white;
  font: 500 10.5px/1.3 'SF Mono', ui-monospace, Menlo, monospace;
  color: ${inkDark};
  flex-shrink: 0;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Accent pill for a turn's reasoning effort level. */
const EffortBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 99px;
  border: 1px solid ${secondaryBase};
  background: ${secondaryLightest};
  font: 600 10px/1.3 'Figtree', sans-serif;
  color: ${secondaryDarkest};
  text-transform: lowercase;
  flex-shrink: 0;
`;

export { EffortBadge, ModelBadge };
